import React, { forwardRef, useState, useImperativeHandle, useEffect } from 'react';
import { useNECaptcha, get } from '@yaotai/common-utils';
import { Input, Statistic } from 'antd';
import { useToggle } from 'ahooks';
import { VerificationCodeInputLayout } from './styles.js';
import { PHONE_LOGIN_VERIFICATION_CODE_INPUT_LOCALE } from './helper.js';

const ACCOUNT_BIND_CODE_NUMBER = 6;
const { Countdown } = Statistic;
const COUNTDOWN_TIME_UNIT = 1000;
const PhoneLoginVerificationCodeInput = forwardRef(({ countdownTime = 60, value, phoneNumber, validate, onChange, onBlur, className, lang = 'zh', aid, getLoginMsgCodeApi, sid, }, ref) => {
    const [code, setCode] = useState(value);
    const [countDownTime, setCountDownTime] = useState(0);
    const [isGettingCode, { toggle }] = useToggle();
    const { captchaIns, getCaptchaIns } = useNECaptcha({
        mode: 'bind',
        onVerify: function (err, data) {
            if (err)
                return;
            onGetCodeBtnClick(data.validate);
        },
    });
    useImperativeHandle(ref, () => ({
        getCaptchaIns,
    }));
    useEffect(() => {
        setCountDownTime(Date.now() + countdownTime * COUNTDOWN_TIME_UNIT);
    }, [isGettingCode]);
    const onCodeChange = (e) => handleCodeChange(e.target.value);
    const handleCodeChange = (code) => {
        setCode(code);
        onChange?.(code);
    };
    // eslint-disable-next-line react-func/max-lines-per-function
    const onGetCodeBtnClick = async (valid, te) => {
        // 校验函数和 phoneNumber 二者至少传其一 如果校验函数用于校验手机号，则优先拿取校验函数返回的经过校验的手机号
        const { phoneInfo } = await validate?.();
        toggle();
        const data = await getLoginMsgCodeApi({
            aid,
            valid,
            sid,
            phone: phoneInfo?.phone,
            region: phoneInfo?.code,
        }).finally(() => getCaptchaIns()?.refresh());
        const code = get(data, 'code', '');
        if (String(code).startsWith('403')) {
            setCode('');
        }
    };
    const handleCaptcha = async () => {
        await validate?.();
        captchaIns?.verify();
    };
    return (React.createElement(VerificationCodeInputLayout, { className: `flex-between ${className}` },
        React.createElement(Input, { className: "yaotai-verification-code-input", onBlur: onBlur, value: code, maxLength: ACCOUNT_BIND_CODE_NUMBER, onChange: onCodeChange, placeholder: PHONE_LOGIN_VERIFICATION_CODE_INPUT_LOCALE[lang]['verificationCodePlaceholder'] }),
        isGettingCode ? (React.createElement("div", { className: "verification-code-button-disabled yaotai-verification-code-button" },
            React.createElement(Countdown, { value: countDownTime, onFinish: toggle, format: "s", suffix: "s" }))) : (React.createElement("div", { className: "verification-code-button yaotai-verification-code-button", onClick: handleCaptcha },
            React.createElement("div", { id: "captcha" }),
            PHONE_LOGIN_VERIFICATION_CODE_INPUT_LOCALE[lang]['getVerificationCode']))));
});

export { ACCOUNT_BIND_CODE_NUMBER, PhoneLoginVerificationCodeInput };
